// ------------------------------------------------------------------------------
// name: useDelayState
// author: mudas
// created: 2025/4/24
// ------------------------------------------------------------------------------

import { useEffect, useRef, useState } from 'react';
import { Timeout } from 'ahooks/lib/useRequest/src/types';

export const useDelayState = <T = any>(initialValue: T, delay: number = 100) => {
  const [value, setValue] = useState<T>(initialValue);
  const lastestRef = useRef<T>(initialValue);
  const timerRef = useRef<Timeout>();

  const cancelTimeout = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
  };

  // 单位时间内，以最后一次值为准，此值之前的所有过程值将被忽略
  const setDelayValue = (newValue: T) => {
    lastestRef.current = newValue;
    if (!timerRef.current) {
      timerRef.current = setTimeout(() => {
        setValue(lastestRef.current);
        timerRef.current = undefined;
      }, delay);
    }
  };

  const resetDelay = () => {
    cancelTimeout();
    timerRef.current = undefined;
  };

  useEffect(() => {
    return () => cancelTimeout();
  }, []);

  return [value, setDelayValue, resetDelay] as const;
};
